var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet-body form" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading > 0,
            expression: "loading > 0"
          }
        ],
        staticClass: "row"
      },
      [
        _c("div", { staticClass: "col-sm-12" }, [
          _c(
            "span",
            [
              _c(
                "div",
                { staticClass: "progress", staticStyle: { margin: "20px 0" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "progress-bar",
                      style: { width: _vm.currentProgress + "%" },
                      attrs: {
                        "aria-valuemax": _vm.progress,
                        "aria-valuenow": _vm.loading,
                        "aria-valuemin": "0",
                        role: "progressbar"
                      }
                    },
                    [
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v(_vm._s(_vm.currentProgress) + "% Complete")
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.$store.state.dateDataIsLoading
                ? _c("h2", [_vm._v(_vm._s(_vm.trans("form.copying")) + "...")])
                : _c("h2", [
                    _vm._v(_vm._s(_vm.trans("form.please_wait")) + "...")
                  ]),
              _vm._v(" "),
              _c("ring-loader")
            ],
            1
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading <= 0,
            expression: "loading <= 0"
          }
        ],
        staticClass: "row"
      },
      [
        _c("div", { staticClass: "col-sm-12" }, [
          _c(
            "form",
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "btn-set pull-right" }, [
                    _c(
                      "button",
                      { staticClass: "btn green", on: { click: _vm.showMenu } },
                      [_vm._v(_vm._s(_vm.trans("menu_planner.show")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-set pull-right",
                      staticStyle: { "margin-right": "8px" }
                    },
                    [
                      _c("menu-planner-history", {
                        attrs: {
                          brand: _vm.brand,
                          date: _vm.date,
                          "route-name":
                            "api_get_entity_logger_show_menu_planner_serving"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.variants, function(variant, variantIndex) {
                return _c(
                  "div",
                  { key: variantIndex, staticClass: "row" },
                  [
                    _c("menu-planner-edit-variant", {
                      attrs: {
                        brand: _vm.brand,
                        date: _vm.date,
                        "meal-types": _vm.mealTypes,
                        variant: variant
                      },
                      on: {
                        "loading-start": _vm.loadingStart,
                        "loading-stop": _vm.loadingStop
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d7707824", { render: render, staticRenderFns: staticRenderFns })
  }
}